interface DetailRowProps {
  label: string;
  value?: React.ReactNode;
  className?: string;
}

export const DetailRow = ({ label, value, className = "" }: DetailRowProps) => {
  const labelClass = "font-semibold max-w-[300px]";

  return (
    <div className={`flex flex-row mt-3 ${className}`}>
      <div className="flex-1">
        <div className={labelClass}>{label}</div>
        <div>{value}</div>
      </div>
    </div>
  );
};
